import React from 'react';
import Cover from './cover.js';
import Image from './image.js';
import * as Icons from './icons.js';
import TimeAgo from './time.js';
import {reisy, use} from 'reisy';
import PropTypes from 'prop-types';

export const styles = reisy`
@namespace Box;

box {
	position: relative;
	width: 25em;
	height: 28.75em;
}
details {
	@extends Helpers.AbsFull;
	font-family: $Fonts.aside;
	top: auto;
	height: 3.75em;
}
detailsLogo {
	@extends Helpers.AbsFull;
	z-index: -1;
	opacity: 0.1;
	display: flex;
	align-items: center;
	justify-content: center;
}
logo {
	height: 75%;
}
author {
	cursor: pointer;
}
authorImage {
	/*
	XXX: because our css-in-js just creates a bunch of flat classnames, that
	have the same specificity, a style that is defined *later* than this
	will override some properties, no matter the order in which we actually
	use the styles :-(
	*/
	position: absolute !important;
	bottom: 0.625em;
	left: 0.625em;
	width: 2.5em;
	height: 2.5em;
}
authorImageUser {
	border-radius: 100%;
	overflow: hidden;
}
authorName {
	font-size: 0.7375em;
	position: absolute;
	bottom: 1.949em;
	left: 5.085em;
	width: calc(50% - 6.356em);
	display: block;
	color: #ccc;
}
time {
	font-size: 0.75em;
	position: absolute;
	bottom: 0.6667em;
	line-height: 1.25em;
	left: 5em;
	color: #808080;
}
`;

const settings = reisy.namespace("Settings");

const Box = ({content, content: {publisher}, style}) => (
	<article
		{...use(styles.box, style, content.options && content.options.className)}>
		<Cover content={content} to={{append: [content]}} transition="zoomin" />
		<div {...use(styles.details)}>
			{settings.Branding && <div {...use(styles.detailsLogo)}>
				<Icons.Logo {...use(styles.logo)} />
			</div>}
			<a {...use(styles.author)} target="_blank" href="#">
				<Image style={[styles.authorImage, publisher.type !== 'publisher' && styles.authorImageUser]} image={publisher.image} />
				<span {...use(styles.authorName)}>{publisher.name}</span>
			</a>
			{settings.ShowTime && <TimeAgo {...use(styles.time)} time={content.publishDate} />}
		</div>
	</article>
);

Box.propTypes = {
	content: PropTypes.object.isRequired,
	style: PropTypes.any,
};

export default Box;



// WEBPACK FOOTER //
// ./lib/components/box.js